export default "__VITE_ASSET__CXagsqSb__"